import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ColumnMode, DatatableComponent} from '@almaobservatory/ngx-datatable';
import {VoTableColumnFiltersService} from "../column-filters/vo-table-column-filters.service";
import {Observable} from "rxjs";
import {VoColumnFilter} from "../column-filters/vo-table-column-filter/vo-table-column-filter.component";
import {ColumnFilter} from "../../search-table/columns-filters/column-filters.service";
import {map, tap} from "rxjs/operators";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

const timeout = 300;

@Component({
  selector: 'asax-result-table-vo-table-container',
  templateUrl: './vo-table-container.component.html',
  providers: [VoTableColumnFiltersService],
  styleUrls: ['./index.scss', './material.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VoTableContainerComponent {
  readonly navHeight = 45;
  readonly headerHeight = 56;

  @ViewChild(DatatableComponent, {static: true}) datatableComponent: DatatableComponent;
  @ViewChild('cellText', {static: false}) cellTextElementRef: ElementRef;
  @ViewChild('tooltip', {static: false}) tooltip: NgbTooltip;


  @Input() id: string;
  @Input() height: number;
  @Input() width: number;
  @Input() columns = [];
  @Input() rows = [];

  reorderable = true;

  ColumnMode = ColumnMode;

  columnFiltersObservable: Observable<VoColumnFilter[]>;
  displayRemove: Observable<boolean>;

  temp = [];

  private timeout: NodeJS.Timeout;

  constructor(private readonly ref: ChangeDetectorRef,
              private readonly columnFiltersService: VoTableColumnFiltersService,) {

  }

  ngOnInit(): void {
    this.columnFiltersObservable = this.columnFiltersService.getColumnFilters().pipe(
      tap(columnsFilters => this.filterRows(columnsFilters))
    );

    this.displayRemove = this.columnFiltersService.getColumnFilters().pipe(
      map(filters => filters.filter(filter => !!filter?.value)),
      map(filters => filters?.length > 0)
    );

    this.temp = [...this.rows || []];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (((changes.height && this.height) || (changes.width && this.width))) {
      this.updateTableView();
    }
  }

  updateTableView(): void {
    setTimeout(() => {
      this.rows = [...this.rows || []];
      this.datatableComponent?.recalculateDims();
      this.ref.markForCheck();
    });
  }

  onColumnFilter(columnFilter: VoColumnFilter): void {
    this.columnFiltersService.upsertColumnFilter(columnFilter);
  }

  onRemoveColumnFilter(filterId: string): void {
    this.columnFiltersService.removeColumnFilter(filterId);
  }

  removeColumnFilters(): void {
    this.columnFiltersService.removeColumnFilters();
  }

  filterRows(columnsFilters: VoColumnFilter[]) {
    let temp = [...this.temp];

    columnsFilters?.filter(column => !column?.isDisabled)
      .filter(column => column?.value?.length > 0)
      .forEach(columnFilter => {
        temp = temp?.filter(row => {
          const val = columnFilter?.value?.toLowerCase();
          return row[columnFilter?.id]?.toLowerCase()?.indexOf(columnFilter?.value) !== -1 || !val
        })
      });

    this.rows = temp;
  }

  openWithTimeout() {
    if (this.cellTextElementRef?.nativeElement?.scrollWidth > this.cellTextElementRef?.nativeElement?.offsetWidth) {
      this.clearTimeout();
      this.timeout = setTimeout(() => this.tooltip?.open(), timeout);
    }
  }

  closeWithTimeout() {
    this.clearTimeout();
    this.timeout = setTimeout(() => this.tooltip.close(), timeout);
  }

  clearTimeout() {
    clearTimeout(this.timeout);
  }
}
